module.exports = __webpack_public_path__ + "img/export-xlsx-file.983683c9.webp";